var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      staticClass: "show",
      attrs: { "label-width": "180px", "label-position": "right" }
    },
    [
      _c("el-form-item", { attrs: { label: "Id" } }, [
        _vm._v(_vm._s(_vm.user.id))
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Email" } }, [
        _vm._v(_vm._s(_vm.user.email))
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Roles" } },
        _vm._l(_vm.user.roles, function(role) {
          return _c("div", { key: role }, [_vm._v(_vm._s(_vm.roleLabel(role)))])
        })
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Created at" } }, [
        _vm._v(_vm._s(_vm._f("formatDatetime")(_vm.user.created)))
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Updated at" } }, [
        _vm._v(_vm._s(_vm._f("formatDatetime")(_vm.user.modified)))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _vm.hasRoleToUpdate
            ? _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-fa-pencil-square-o",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      _vm.edit()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("table.edit")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-fa-history", type: "infor" },
                  on: {
                    click: function($event) {
                      _vm.history()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("table.history")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadActivity
            ? _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-fa-eye", type: "infor" },
                  on: {
                    click: function($event) {
                      _vm.activity()
                    }
                  }
                },
                [_vm._v("Activity")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0017d2d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0017d2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-detail.vue
// module id = null
// module chunks = 